export const extractDateFromToken = (
  input: string | undefined,
): Date | undefined => {
  if (!input) return undefined;

  const match = input.match(/(\d{2})(\d{2})(\d{2})/);

  if (match) {
    const [_, day, month, year] = match;
    const fullYear =
      parseInt(year ?? '', 10) > 50
        ? 1900 + parseInt(year ?? '', 10)
        : 2000 + parseInt(year ?? '', 10);
    return new Date(
      fullYear,
      parseInt(month ?? '', 10) - 1,
      parseInt(day ?? '', 10),
    );
  }

  return undefined;
};

export const extractInitialsFromToken = (
  input: string | undefined,
): { herName: string; hisName: string } | undefined => {
  if (!input) return undefined;

  const match = input.match(/\d+([a-zA-Z]{1})([a-zA-Z]{1})$/);

  if (match) {
    const [_, herName, hisName] = match;

    return { herName: herName ?? '', hisName: hisName ?? '' };
  }

  return undefined;
};
